<div class="row py-2 array-of-line-card">
  <div class="col-auto">{{ ArrayOfLineCard.PartNumber }}</div>
  <div class="col-auto">{{ ArrayOfLineCard.PartDesc }}</div>
</div>
